"use client";

import * as React from "react";
import { motion } from "framer-motion";
import { Briefcase, ArrowRight, Award } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";
const electricians = [{
  id: 1,
  name: "Michael Chen",
  photo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1745538/img/electrician_michael_chen.webp",
  focus: "Electrical Specialist",
  experience: "Residential & Commercial",
  specialties: ["Panel Upgrades", "Smart Home"]
}, {
  id: 2,
  name: "Sarah Jenkins",
  photo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1745538/img/electrician_sarah_jenkins.png",
  focus: "Electrical Specialist",
  experience: "Residential Installations",
  specialties: ["Rewiring", "EV Chargers"]
}, {
  id: 3,
  name: "David Rodriguez",
  photo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1745538/img/electrician_david_rodriguez.webp",
  focus: "Electrical Specialist",
  experience: "Troubleshooting & Systems",
  specialties: ["Repairs", "Troubleshooting"]
}, {
  id: 4,
  name: "James Wilson",
  photo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1745538/img/electrician_james_wilson.webp",
  focus: "Electrical Specialist",
  experience: "Modern Systems & Lighting",
  specialties: ["Lighting Design", "Generators"]
}];
const containerVariants = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: "easeOut"
    }
  }
};
export default function MasterElectricians() {
  return <section id="meetourmasterelectricians" className="bg-background py-16 md:py-24">
      <div className="container mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-12 text-center md:mb-16">
          <motion.h2 initial={{
          opacity: 0,
          y: -20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="font-default text-3xl font-bold tracking-tight text-foreground sm:text-4xl">
            Featured Electrical Pros
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: -20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="mx-auto mt-4 max-w-2xl text-lg text-muted-foreground">
            Independent local electrical professionals in our network are ready to assist with your residential repair and installation projects.
          </motion.p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
        once: true,
        amount: 0.1
      }} className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {electricians.map((pro, i) => <motion.div key={pro.id} variants={itemVariants} data-index={i}>
              <Card className="h-full overflow-hidden transition-shadow duration-300 hover:shadow-md">
                <div className="relative">
                  <AspectRatio ratio={4 / 3}>
                    <img src={pro.photo} alt={`Portrait of ${pro.name}`} className="size-full object-cover" data-wvc-srcset={`${pro.photo}-wvc-srcset`} data-wvc-sizes={`${pro.photo}-wvc-sizes`} loading="lazy" />
                  </AspectRatio>
                </div>
                
                <CardHeader className="pb-4">
                  <CardTitle className="font-default text-xl">{pro.name}</CardTitle>
                  <CardDescription className="flex items-center gap-1.5 text-primary">
                    <Award className="size-4" />
                    <span className="font-medium">{pro.focus}</span>
                  </CardDescription>
                </CardHeader>
                
                <CardContent>
                  <div className="mb-4 flex items-center gap-2 text-sm text-muted-foreground">
                    <Briefcase className="size-4" />
                    <span>{pro.experience}</span>
                  </div>
                  
                  <div className="space-y-2">
                    <p className="text-xs font-medium uppercase tracking-wider text-muted-foreground">Specialties</p>
                    <div className="flex flex-wrap gap-2">
                      {pro.specialties.map((specialty, index) => <Badge key={index} variant="secondary" className="bg-secondary/10 text-secondary-foreground hover:bg-secondary/20">
                          {specialty}
                        </Badge>)}
                    </div>
                  </div>
                </CardContent>
              </Card>
            </motion.div>)}
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="mt-12 flex justify-center md:mt-16">
          <Button asChild size="lg" className="group">
            <Link to="#bookingrequest">
              Request a Quote
              <ArrowRight className="ml-2 size-4 transition-transform group-hover:translate-x-1" />
            </Link>
          </Button>
        </motion.div>
      </div>
    </section>;
}